import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {SelectTipo} from './../interface/selectTipo.interface';
import {Router} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import {
    DialogOverviewDialogComponent
} from './../commons/modal/dialog-overview-dialog/dialog-overview-dialog.component';

import {RespValidaItuInterface, ValidaItuInterface, ItuResult} from './../interface/array-itu.interface';
import {ResponseString} from './../interface/response-string';
import {Itu} from '../models/itu';

import {GeneraItuService} from '../services/genera-itu.service';

import swal from 'sweetalert2';
import {NgxSpinnerService} from 'ngx-spinner';
import {AppConfigService} from '../app-config.service';
import {ActivatedRoute} from '@angular/router';
import {ViewChild} from '@angular/core';
import {NoFacturablesDialogComponent} from './Dialogs/NoFacturablesDialog.component';
import {AddressService} from '../services/address.service';
import {IngresaRfcComponent} from './ingresa-rfc/ingresa-rfc.component';
import {ListOrdersService, OrdersDTO} from '../services/list-orders.service';
import {AuthService} from '../services/auth-service';
import {QrScannerComponent} from '../qr-scanner-dialog/qr-scanner.component';
import {MobileDetectionService} from '../services/mobile-detection.service';
import {CanComponentDeactivate} from '../interface/can-component-deactivate.interface';


@Component({
    selector: 'app-genera-f',
    templateUrl: './genera-f.component.html',
    styleUrls: ['./genera-f.component.css']
})
export class GeneraFComponent implements OnInit, CanComponentDeactivate {
    colorBtn = this.configService.getConfig().colorBtn;
    isMobile$ = this.mobileService.isMobile$;

    constructor(private generaItuService: GeneraItuService,
                private router: Router,
                private route: ActivatedRoute,
                public dialog: MatDialog,
                private spinnerService: NgxSpinnerService,
                private configService: AppConfigService,
                private fb: FormBuilder,
                private listOrdersService: ListOrdersService,
                private authService: AuthService,
                private mobileService: MobileDetectionService) {

        this.backgroundMsg = this.configService.getConfig().backgroundMsg;
        this.logoMsg = this.configService.getConfig().logoMsg;
        this.colorTexto = this.configService.getConfig().colorTexto;
        this.classBtn = this.configService.getConfig().classBtn;
        this.telefono1 = this.configService.getConfig().telefono1;
        this.telefono2 = this.configService.getConfig().telefono2;
        this.emailAtencion = this.configService.getConfig().emailAtencion;
        this.imgTicket = this.configService.getConfig().imgTicket;
        this.imgEcommerceTmk = this.configService.getConfig().imgEcommerceTmk;
        this.imgMeli = this.configService.getConfig().imgMeli;
        this.colorBtn = this.configService.getConfig().colorBtn;
        sessionStorage.clear();
        this.arrTypeOrder = [{id: '1', description: 'Tienda'}, {
            id: '2',
            description: 'Sitio Web y APP Movil'
        }, {id: '3', description: 'Telemarketing'}, {id: '4', description: 'Mercado Libre'}];
        sessionStorage.clear();
    }

    qrResult = '';
    // Arreglo para alamcenar mínimo 1 ITU, máximo de 20 ITU´s
    ituArray: Itu[] = [];
    ituMap = new Map();
    display = false;
    billingId: number;
    itu = '';
    amount = 0;
    backgroundMsg = '';
    logoMsg = '';
    colorTexto = '';
    classBtn = '';
    telefono1 = '';
    telefono2 = '';
    emailAtencion = '';
    dialogResponse: boolean;
    typeOrder = '1';
    imgTicket = '';
    imgEcommerceTmk = '';
    imgMeli = '';
    itulength = 30;
    subOrden = '';
    regex = /^[0-9]*$/;
    company = '';

    arrayOrders: any[] = [];

    // textValue: string;

    ituSendArray: string[] = [];

    respValidaItu: RespValidaItuInterface;

    restart = 0;

    // Form para datos de formulario
    myForm: FormGroup;
    arrTypeOrder: SelectTipo[] = [];

    // Bandera para activar el boton aceptar
    activateButton: Boolean = true;

    activeButton: Boolean = false;

    // Data para resetear el Form
    data: Itu = {
        id: null,
        itu: null,
        status: false,
        msg: null
    };

    // Bandera para controlar el procesamiento de ITU's
    procesar = false;

    continueStep = false;

    // ituValidation: ArrayItu;

    validaItu: ValidaItuInterface;

    ituSeriesArray: string[] = [];
    totalItusResp = 0;

    orderNumber: boolean;
    puedeSalir = false;

    form: FormGroup;
    isLoged = false;

    ituParam: string;
    montoParam: string;
    tipoParam: string;

    monto: number | null = null;

    isHybris: boolean;
    protected readonly String = String;

    urlSegments: string[] = [];

    bloquearSalida = false;

    changeHybris() {
        this.isHybris = true;
    }

    async canDeactivate(): Promise<boolean> {
        const result = await swal({
            text: 'Se cancelará el proceso de Facturación. ¿Desea continuar?',
            type: 'question',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: this.colorTexto,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, estoy seguro'
        });
        if (result.value) {
            console.log('-------------- SALIENDO... --------------');
            this.cancel(true);
        }
        return result.value;
    }

    ngOnInit() {
        console.log('Componente iniciado. display:', this.display, 'puedeSalir:', this.puedeSalir);

        console.log('ngOnInit está ejecutandose');
        console.log('isLoged', this.isLoged);
        this.company = this.configService.getConfig().companyName;

        this.colorBtn = this.configService.getConfig().colorBtn;

        this.arrayOrders = [];
        console.log('arrayOrders', this.arrayOrders);

        this.authService.getIsLoggedIn().subscribe(isLoggedIn => {
            console.log('isLoggedIn', isLoggedIn);
            this.isLoged = isLoggedIn; // 🔥 Ahora usa el valor correcto
            if (this.isLoged) {
                this.obtenerListaDeOrdenes();
            }
        });


        this.myForm = new FormGroup({
            'id': new FormControl(0),
            'itu': new FormControl(
                '',
                [
                    Validators.required,
                    Validators.minLength(30),
                    Validators.maxLength(30),
                    Validators.pattern(/20([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])([0-9]{5})([0-9]{3})([0-9]{9})[pP][oO][sS][abAB](0|1|9)/)
                ]
            ),
            'monto': new FormControl(
                '',
                [
                    Validators.required,
                    Validators.min(0.01)
                ]
            ),
            'typeOrder': new FormControl('1'),
            'order': new FormControl('')
        });

        this.ituParam = this.route.snapshot.paramMap.get('itu');
        this.montoParam = this.route.snapshot.paramMap.get('monto');
        this.tipoParam = this.route.snapshot.paramMap.get('tipo');

        if (this.tipoParam != null) {

            this.subOrden = this.ituParam.substring(0, 6);
            console.log(this.subOrden);
            if (this.regex.test(this.subOrden)) {
                this.myForm.get('typeOrder').setValue(this.tipoParam);
                this.changeOrigin(this.myForm, 'descripcion', 'ituTxt');
            } else {
                // let encodedITU: string = btoa(this.itu); //Encode
                const encodedTipo: string = atob(this.tipoParam); // Decode

                console.log(this.tipoParam);
                console.log(encodedTipo);

                this.myForm.get('typeOrder').setValue(encodedTipo);
                this.changeOrigin(this.myForm, 'descripcion', 'ituTxt');
            }
        }

        if (this.ituParam != null && this.montoParam != null) {

            this.subOrden = this.ituParam.substring(0, 6);
            console.log(this.subOrden);
            if (this.regex.test(this.subOrden)) {
                this.myForm.get('itu').setValue(this.ituParam);
                this.itu = this.ituParam;
                this.myForm.get('monto').setValue(this.montoParam);
            } else {
                // let encodedITU: string = btoa(this.itu); //Encode
                const encodedITU: string = atob(this.ituParam); // Decode

                console.log(this.ituParam);
                console.log(encodedITU);

                this.myForm.get('itu').setValue(encodedITU);
                this.itu = encodedITU;

                // let encodedMonto: string = btoa(this.monto); //Enconde
                const encodedMonto: string = atob(this.montoParam); // Deconde

                console.log(this.montoParam);
                console.log(encodedMonto);

                this.myForm.get('monto').setValue(encodedMonto);
            }
        }
    }

    openScannerDialog(): void {
        const dialogRef = this.dialog.open(QrScannerComponent, {
            width: '80%',
            maxWidth: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.qrResult = result;
                console.log('Resultado del QR:', result);

                const segments = this.qrResult.replace(/^https?:\/\//, '').split('/');

                this.urlSegments = segments.filter(segment => segment !== '');
                console.log('urlSegments', this.urlSegments);

                console.log('itu', this.urlSegments[3]);
                console.log('monto', this.urlSegments[4]);

                // let encodedITU: string = btoa(this.itu); //Encode
                const encodedITU: string = atob(this.urlSegments[3]); // Decode

                console.log(this.urlSegments[3]);
                console.log(encodedITU);

                this.myForm.get('itu').setValue(encodedITU);
                this.itu = encodedITU;

                // let encodedMonto: string = btoa(this.monto); //Enconde
                const encodedMonto: string = atob(this.urlSegments[4]); // Deconde

                console.log(this.urlSegments[4]);
                console.log(encodedMonto);

                this.myForm.get('monto').setValue(encodedMonto);
            }
        });
    }

    obtenerListaDeOrdenes() {
        this.listOrdersService.getListOrders().subscribe(
            (data) => {
                console.log('Órdenes obtenidas en ngOnInit:', data);

                const today = new Date();
                const aMonth = new Date();
                aMonth.setDate(today.getDate() - 60);

                // Verifica si "orders" existe antes de modificarlo
                if (data.orders && Array.isArray(data.orders)) {
                    this.arrayOrders = data.orders
                        .filter(order => {
                            const placedDate = new Date(order.placed);
                            return placedDate >= aMonth;
                        })
                        .map(order => ({
                            ...order,
                            placed: new Date(order.placed).toLocaleDateString('es-ES') // Formatear en formato 'yyyy-MM-dd'
                        }));
                } else {
                    this.arrayOrders = [];
                }

                console.log('Órdenes filtradas del último mes:', this.arrayOrders);
            },
            (error) => {
                console.error('Error al obtener órdenes:', error);
            }
        );
    }


// Agrega Itu al arreglo si la validación del Back-End es true
    validateItu(myFormAux: FormGroup) {
        console.log('validateItu esta ejecutandose');

        this.activateButton = false;
        this.spinnerService.show();

        const ituForm = myFormAux.controls['itu'].value.toUpperCase();
        const amountForm = myFormAux.controls['monto'].value;

        this.itu = ituForm.replace(/^0+/, "");
        this.amount = myFormAux.controls['monto'].value;
        this.typeOrder = myFormAux.controls['typeOrder'].value;

        sessionStorage.setItem('amountReinvoice', String(this.amount));
        sessionStorage.setItem('ituReinvoice', this.itu);
        sessionStorage.setItem('typeOrder', this.typeOrder);

        if (sessionStorage.getItem('billingId') === null) {

            this.validaItu = {

                billingId: 0,
                auxBillingId: 0,
                itu: ituForm,
                amount: amountForm,
                listItus: this.ituSendArray,
                xstore: '',
                series: this.ituSeriesArray,
                totalItus: 0,
                typeOrder: this.typeOrder

            };

        } else {
            this.validaItu = {

                billingId: Number(sessionStorage.getItem('billingId')),
                auxBillingId: Number(sessionStorage.getItem('auxBillingId')),
                itu: ituForm, amount: amountForm, listItus: this.ituSendArray,
                xstore: sessionStorage.getItem('xstore'),
                series: this.ituSeriesArray = [sessionStorage.getItem('ituSerie')],
                totalItus: Number(sessionStorage.getItem('totalItu'))

            };
        }

        if (Number(this.typeOrder) === 1 || Number(this.typeOrder) === 4) {
            if (this.totalItusResp <= Number(sessionStorage.getItem('totalItu'))) {
                this.generaItuService.validateItu(this.validaItu).subscribe((data: RespValidaItuInterface) => {
                    console.log('DATA: ', data);

                    this.activateButton = true;

                    if (data.status) {
                        console.log(data.object.validationMsg);

                        if (data.object.validationMsg === 'OK') {
                            if (data.ticketMixto) {

                                const dialogConfig = new MatDialogConfig();

                                dialogConfig.width = '700px'; // Ajusta el ancho del diálogo
                                dialogConfig.data = {'itu': this.itu};


                                const dialogRef = this.dialog.open(NoFacturablesDialogComponent, dialogConfig);
                                dialogRef.afterClosed().subscribe(result => {

                                    if (result) {

                                        sessionStorage.setItem('billingId', String(data.object.billingId));
                                        sessionStorage.setItem('ituSerie', String(data.object.series[0]));
                                        sessionStorage.setItem('totalItu', String(data.object.totalItus));
                                        sessionStorage.setItem('xstore', String(data.object.xstore));
                                        sessionStorage.setItem('auxBillingId', String(data.object.auxBillingId));
                                        sessionStorage.setItem('itu', this.myForm.get('itu').value);


                                        this.insertItuArray(data.object.itu);
                                        this.puedeSalir = true;
                                        this.router.navigate(['/ingresaRfc']);

                                    } else {

                                        this.reiniciarProceso();
                                        console.log('Cancelar presionado');

                                    }
                                });

                            } else {
                                sessionStorage.setItem('billingId', String(data.object.billingId));
                                sessionStorage.setItem('ituSerie', String(data.object.series[0]));
                                sessionStorage.setItem('totalItu', String(data.object.totalItus));
                                sessionStorage.setItem('xstore', String(data.object.xstore));
                                sessionStorage.setItem('auxBillingId', String(data.object.auxBillingId));
                                sessionStorage.setItem('itu', this.myForm.get('itu').value);


                                this.insertItuArray(data.object.itu);
                                this.puedeSalir = true;
                                this.router.navigate(['/ingresaRfc']);
                            }


                            this.spinnerService.hide();
                        } else {

                            if (data.object.validationMsg.includes('No existe información para esta orden de compra')) {
                                this.spinnerService.show();
                                this.validateItuReinvoice();
                            } else if (data.object.validationMsg.toLowerCase().includes('itu previamente facturado')) {
                                this.spinnerService.hide();
                                swal({
                                    text: 'Este ticket fue previamente facturado, ¿esta seguro que quiere volver a facturarlo?',
                                    type: 'question',
                                    showCancelButton: true,
                                    reverseButtons: true,
                                    confirmButtonColor: this.colorTexto,
                                    cancelButtonText: 'Cancelar',
                                    confirmButtonText: 'Si, estoy seguro'
                                }).then((result) => {
                                    console.log('entre a la funcion: ' + sessionStorage.getItem('ituReinvoice'));


                                    if (result.dismiss == null) {
                                        if (data.ticketMixto) {
                                            const dialogConfig = new MatDialogConfig();
                                            dialogConfig.width = '700px'; // Ajusta el ancho del diálogo
                                            dialogConfig.data = {'itu': this.itu};


                                            const dialogRef = this.dialog.open(NoFacturablesDialogComponent, dialogConfig);

                                            dialogRef.afterClosed().subscribe(res => {
                                                if (res) {
                                                    this.spinnerService.show();
                                                    this.validateItuReinvoice();
                                                } else {
                                                    this.myForm.reset();
                                                    return;
                                                    console.log('Cancelar presionado');
                                                }
                                            });
                                        } else {
                                            this.spinnerService.show();
                                            this.validateItuReinvoice();
                                        }


                                    } else {
                                        this.spinnerService.hide();
                                    }


                                });

                            } else {
                                this.myForm.get('itu').setValue('');
                                this.myForm.get('monto').setValue('');
                                this.itu = '';
                                this.spinnerService.hide();
                                swal('Error!', data.object.validationMsg, 'error');
                            }
                        }

                    } else {
                        // this.myForm.reset();
                        this.spinnerService.hide();
                        swal('Error!', 'Error al validar el ITU, vuelve a intentarlo', 'error');
                    }
                }, err => {
                    this.spinnerService.hide();
                    this.myForm.get('itu').setValue('');
                    this.myForm.get('monto').setValue('');
                    this.itu = '';
                    this.amount = 0;
                    swal('Error!', 'Error al conectar con el Servidor. Se va reinciar la página', 'error');

                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);

                });
            } else {
                this.spinnerService.hide();
                swal('Error!', `El límite de ITU´s es ${Number(sessionStorage.getItem('totalItu'))}`, 'warning');
            }
        } else if (Number(this.typeOrder) === 2 || Number(this.typeOrder) === 3) {
            this.spinnerService.show();
            this.validateItuReinvoice();
        }
    }

// Inserta ITU´s al arreglo temporal
    insertItuArray(itu: string) {
        console.log('Inserto en array');
        this.spinnerService.hide();
        const selectedItu: Itu = new Itu();
        selectedItu.itu = itu;
        if (this.restart === 0) {
            selectedItu.id = this.ituArray.length + 1;
        } else {
            selectedItu.id = this.ituArray.length;
        }
        selectedItu.status = true;
        this.maxAddArrayItu(selectedItu);

    }

// Determina la cantidad de ITU´s a almacenar al array
    maxAddArrayItu(ituObject: Itu) {
        const totItu = Number(sessionStorage.getItem('totalItu'));
        if (this.restart !== 1) {
            this.maxLength(totItu, ituObject);
        } else {
            this.maxLength(totItu + 1, ituObject);
        }
    }

    // Almacena los ITU´s al arreglo
    maxLength(max: number, ituObject: Itu) {
        if (this.ituArray.length < max) {
            this.ituArray.push(ituObject);
            this.ituSendArray.push(ituObject.itu);
            swal('', 'Validación exitosa', 'success');
        } else {
            swal('', `El límite de ITU´s es ${Number(sessionStorage.getItem('totalItu'))}`, 'warning');
        }
    }

    // Valida (Back-End) el arreglo de ITU's
    procesarItus() {
        swal('', 'ITU´s guardados exitosamente', 'success');
        this.router.navigate(['/ingresaRfc']);
    }

    // Reinicia el proceso de Genera Factura
    reiniciarProceso() {
        swal({
            text: '¿Realmente deseas cancelar el proceso de generación de factura?',
            type: 'question',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: this.colorTexto,
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            console.log('entre a la funcion: ' + sessionStorage.getItem('ituReinvoice'));

            if (result.dismiss == null) {
                console.log(this.ituArray);
                console.log('billingId = ' + Number(sessionStorage.getItem('billingId')));

                this.validaItu = {
                    billingId: Number(sessionStorage.getItem('billingId')),
                    auxBillingId: Number(sessionStorage.getItem('auxBillingId')),
                    itu: '', amount: 0, listItus: this.ituSendArray,
                    xstore: sessionStorage.getItem('xstore'),
                    series: this.ituSeriesArray = [sessionStorage.getItem('ituSerie')],
                    totalItus: Number(sessionStorage.getItem('totalItu'))
                };

                this.generaItuService.releaseItus(this.validaItu).subscribe((data: object) => {
                    console.log('DATA: ', data);
                    if (data != null) {
                        if (data['object'] === 'OK') {
                            this.router.navigate(['/home']);
                        } else {
                            this.spinnerService.hide();
                            swal('Error', 'Error al conectar con el Servidor', 'error');
                        }
                    } else {
                        this.spinnerService.hide();
                        swal('Error', 'Error al conectar con el Servidor', 'error');
                    }

                }, err => {
                    console.error(err);
                    this.spinnerService.hide();
                    swal('Error', 'Error al conectar con el Servidor', 'error');
                });

                this.myForm.reset(this.data);
                this.ituArray = [];
                this.ituSendArray = [];
                this.ituSeriesArray = [];
                this.restart = 0;
                this.totalItusResp = 0;
                sessionStorage.clear();
            }
        });
    }

    removeItu(ituDeleted: string) {

        const ituDeleteArray = [ituDeleted];

        this.validaItu = {
            billingId: Number(sessionStorage.getItem('billingId')),
            auxBillingId: Number(sessionStorage.getItem('auxBillingId')),
            itu: '', amount: 0, listItus: ituDeleteArray,
            xstore: sessionStorage.getItem('xstore'),
            series: this.ituSeriesArray = [sessionStorage.getItem('ituSerie')],
            totalItus: Number(sessionStorage.getItem('totalItu'))
        };

        this.generaItuService.releaseItus(this.validaItu).subscribe((data: object) => {
            console.log('DATA: ', data);
            if (data != null) {
                if (data['object'] === 'OK') {
                    const ituPos = this.ituSendArray.indexOf(ituDeleted);
                    this.ituSendArray.splice(ituPos, 1);

                    this.ituArray = [];

                    if (this.ituSendArray.length > 0) {
                        for (let index = 0; index < this.ituSendArray.length; index++) {
                            const ituSelect: Itu = new Itu();
                            ituSelect.id = index + 1;
                            ituSelect.itu = this.ituSendArray[index];
                            this.ituArray.push(ituSelect);
                        }
                    } else {
                        this.myForm.reset(this.data);
                        this.ituArray = [];
                        this.ituSendArray = [];
                        this.ituSeriesArray = [];
                        this.restart = 0;
                        this.totalItusResp = 0;
                        sessionStorage.clear();
                    }

                    swal('', 'Itu ' + ituDeleted + 'eliminado correctamente', 'success');
                } else {
                    this.spinnerService.hide();
                    swal('Error', 'Error al conectar con el Servidor', 'error');
                }
            } else {
                this.spinnerService.hide();
                swal('Error', 'Error al conectar con el Servidor', 'error');
            }

        }, err => {
            console.error(err);
            this.spinnerService.hide();
            swal('Error', 'Error al conectar con el Servidor', 'error');
        });

    }

    validateItuReinvoice() {

        if (sessionStorage.getItem('billingId') === null) {
            this.validaItu = {
                billingId: 0,
                auxBillingId: 0,
                itu: sessionStorage.getItem('ituReinvoice'),
                amount: Number(sessionStorage.getItem('amountReinvoice')),
                listItus: [],
                xstore: '',
                series: [],
                totalItus: 0,
                typeOrder: this.typeOrder
            };
        }

        this.generaItuService.validateItuReinvoice(this.validaItu).subscribe((data: RespValidaItuInterface) => {
            console.log('DATA: ', data);
            this.activateButton = true;
            if (data.status) {
                if (data.object.validationMsg === 'OK') {
                    if (data.object.billingId > 0) {
                        // console.log('billingId ' + data.object.billingId);
                        sessionStorage.setItem('billingId', String(data.object.billingId));
                        sessionStorage.setItem('realItu', String(data.object.realItu));
                    }
                    this.ituSendArray = data.object.listItus;

                    this.display = true;
                    this.spinnerService.hide();
                    this.accept();
                } else {
                    this.myForm.get('itu').setValue('');
                    this.myForm.get('monto').setValue('');
                    swal('Error!', data.object.validationMsg, 'error');
                    this.spinnerService.hide();
                }
            } else {
                this.myForm.reset();
                this.spinnerService.hide();
                swal('Error!', 'Error al validar el ITU, vuelve a intentarlo', 'error');
            }
        }, err => {
            console.error(err);
            this.myForm.get('itu').setValue('');
            this.myForm.get('monto').setValue('');
            this.itu = '';
            this.spinnerService.hide();
            swal('Error!', 'Error al conectar con el Servidor', 'error');
        });
    }

    accept() {
        this.spinnerService.show();
        sessionStorage.setItem('itu', String(this.itu));
        this.spinnerService.hide();
        this.bloquearSalida = false;
        this.puedeSalir = true;
        this.display = false;
        this.router.navigate(['/reinvoiceEditData']);
    }

    async cancel(isCanDeactivate: boolean) {
        let confirmar = true;

        if (!isCanDeactivate) {
            const result = await swal({
                text: 'Se cancelará el proceso de Facturación. ¿Desea continuar?',
                type: 'question',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: this.colorTexto,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si, estoy seguro'
            });

            confirmar = result.value;
        }

        if (confirmar) {

            this.bloquearSalida = !isCanDeactivate;
            this.puedeSalir = isCanDeactivate;
            this.display = false;

            this.spinnerService.show();
            this.billingId = Number(sessionStorage.getItem('billingId'));
            this.validaItu = {
                billingId: this.billingId,
                auxBillingId: 0,
                itu: this.itu,
                amount: this.amount,
                listItus: this.ituSendArray,
                xstore: '',
                series: this.ituSeriesArray,
                totalItus: 1
            };
            this.generaItuService.cancelReinvoice(this.validaItu).subscribe((data: ResponseString) => {
                console.log('DATA: ', data);
                if (data !== null) {
                    if (data.status) {
                        if (data.object !== null) {
                            if (data.object === 'OK') {
                                this.display = false;
                                swal('', 'Solicitud de re.factura del itu: ' + this.itu + ' iniciada.', 'success');
                                this.spinnerService.hide();
                                window.location.reload();
                            } else {
                                swal('Error!', data.object, 'error');
                                this.spinnerService.hide();
                            }
                        } else {
                            this.spinnerService.hide();
                            swal('Error!', 'Error al validar el ITU, vuelve a intentarlo', 'error');
                        }
                    } else {
                        this.spinnerService.hide();
                        swal('Error!', 'Error al validar el ITU, vuelve a intentarlo', 'error');
                    }
                }
            }, err => {
                console.error(err);
                this.spinnerService.hide();
                swal('Error!', 'Error al conectar con el Servidor', 'error');
            });
            console.log('Cancel');
        }
    }

    selectAll($event: MouseEvent) {
        const input = event.target as HTMLInputElement;
        input.select();
    }

    changeOrigin(tForm: FormGroup, labelDescripcion, ituTxt) {
        this.typeOrder = tForm.controls['typeOrder'].value;
        this.myForm.get('itu').setValue('');
        if (this.typeOrder === '1') {
            this.orderNumber = false;
            this.itulength = 30;
            document.getElementById(labelDescripcion).innerHTML = 'Número de ticket (ITU)';
            document.getElementById(ituTxt).setAttribute('maxlength', '30');
            document.getElementById(ituTxt).setAttribute('placeholder', 'Ingresa el ITU');
            this.myForm.controls['itu'].setValidators([Validators.required,
                Validators.required,
                Validators.minLength(30),
                Validators.maxLength(30),
                Validators.pattern(/20([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])([0-9]{5})([0-9]{3})([0-9]{9})[pP][oO][sS][abAB](0|1|9)/)
            ]);
        } else if (this.typeOrder === '2' || this.typeOrder === '3') {
            this.orderNumber = true;

            this.itulength = 9;
            document.getElementById(labelDescripcion).innerHTML = 'Número de orden';
            document.getElementById(ituTxt).setAttribute('maxlength', '9');
            document.getElementById(ituTxt).setAttribute('placeholder', 'Ingresa el número de orden');
            this.myForm.controls['itu'].setValidators([Validators.required,
                Validators.required,
                Validators.maxLength(9),
                Validators.minLength(8),
                Validators.pattern(/^([0-9])*$/)
            ]);
        } else if (this.typeOrder === '4') {
            this.itulength = 16;
            document.getElementById(labelDescripcion).innerHTML = 'Número de orden';
            document.getElementById(ituTxt).setAttribute('maxlength', '16');
            document.getElementById(ituTxt).setAttribute('placeholder', 'Ingresa el número de orden');
            this.myForm.controls['itu'].setValidators([Validators.required,
                Validators.required,
                Validators.maxLength(16),
                Validators.minLength(16),
                Validators.pattern(/^([0-9])*$/)
            ]);
        }
    }

    getPlaceHolder() {
        if (this.typeOrder === '1') {
            return 'Ingresa el ITU';
        }
        if (this.typeOrder === '2' || this.typeOrder === '3' || this.typeOrder === '4') {
            return 'Ingresa el número de orden';
        }
    }

    onOrderSelect() {
        console.log('value', this.myForm.value.officeDepotOrderId);

        // tslint:disable-next-line:no-non-null-assertion
        const selected = this.myForm.get('order')!.value;
        if (!selected) {
            return; // si eligió “Ninguno” no validamos
        }

        this.listOrdersService.validateOrder(this.myForm.value.order.code).subscribe((isValid: boolean) => {
            if (isValid) {

                const orderCode = this.myForm.value.officeDepotOrderId;
                console.log('orderCode', orderCode);

                const selectedOrder = this.arrayOrders.find(order => order.officeDepotOrderId === this.myForm.value.order.officeDepotOrderId);
                console.log('selectedOrder', selectedOrder);

                if (selectedOrder && selectedOrder.total && selectedOrder.total.value) {
                    // Actualizamos el monto en el formulario
                    console.log('Monto:', selectedOrder.total.value);
                    this.myForm.get('monto').setValue(selectedOrder.total.value);
                    console.log('itu', selectedOrder.officeDepotOrderId);
                    this.myForm.get('itu').setValue(selectedOrder.officeDepotOrderId);
                } else {
                    // Si no se encuentra el monto, asignamos 0 como valor por defecto
                    this.myForm.get('monto').setValue(0);
                }
            } else {
                swal(
                    'Atención',
                    'La orden aún no ha sido entregada al cliente o no ha finalizado su proceso de entrega. Por favor, espera a que se complete para poder facturar.',
                    'warning');

                // tslint:disable-next-line:no-non-null-assertion
                this.myForm.get('order')!.setValue('');
                this.myForm.patchValue({monto: '', itu: ''});
            }
        });
    }
}
